import axios from "axios";

const API = axios.create({baseURL: "https://supertweet-backend-api.onrender.com"});

API.interceptors.request.use((req) => {
    if(localStorage.getItem('profile')){
        req.headers.authorization = `Bearer ${JSON.parse(localStorage.getItem('profile')).token}`
    }
    return req;
});

export const getUser = (userId) => API.get(`/user/${userId}`);
export const updateUser = (id, userData) => API.put(`/user/${id}`, userData);

export const getAllUser = () => API.get('/user');

export const followUser = (id, data) => API.put(`/user/${id}/follow`, data);
export const unFollowUser = (id, data) => API.put(`/user/${id}/unfollow`, data);